export const SECRET = 'GCHVpeEL6h7uVBVJ30v0PaJ6v5iprScv91ReSWPP'
